// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-family:\"ICON_FONT_LOADER_FONTFACE(fontName)\";src:ICON_FONT_LOADER_FONTFACE(src)}", ""]);
// Exports
module.exports = exports;
